export const useRodoTitle = () => {
  const { t } = useI18n()
  const titles = {
    0: {
      title: t('rodo.step0.title'),
      subtitle: t('rodo.step0.subtitle'),
    },
    1: {
      title: t('rodo.step1.title'),
      subtitle: t('rodo.step1.subtitle'),
    },
    // title for yourself form
    2: {
      title: t('rodo.step2.title'),
      subtitle: t('rodo.step2.subtitle'),
    },
    // title for child form
    3: {
      title: t('rodo.step3.title'),
      subtitle: t('rodo.step3.subtitle'),
    },
    // title for other person
    4: {
      title: t('rodo.step4.title'),
      subtitle: t('rodo.step4.subtitle'),
    },
  }

  return {
    titles,
  }
}
